/**
 * `URL.parse()` is newer than it looks: Chrome shipped it in 126, Safari in 18
 * and Firefox in 126 - all well above the browsers this build targets. Nothing
 * warns us, because TypeScript declares it in `lib.dom.d.ts` unconditionally.
 *
 * pdf.js reaches it from `PDFWorker._isSameOrigin()` while spinning up its
 * worker. That call sits inside a `try`, so on an older browser the failure is
 * silent rather than loud: pdf.js gives up on the worker, latches
 * `#isWorkerDisabled` for the rest of the page and parses every document on the
 * main thread instead. Pages do render - they just lock the tab while they do -
 * which is exactly the kind of "looks fixed" we do not want to ship.
 */

// Keeps this file a module, so importing it for its side effect stays legal.
export {};

if (typeof URL.parse !== "function") {
  URL.parse = function parse(url: string | URL, base?: string | URL) {
    try {
      // `URL.parse` reports a bad input as null where the constructor throws.
      return base === undefined ? new URL(url) : new URL(url, base);
    } catch {
      return null;
    }
  };
}
